export default __webpack_public_path__ + "static/media/arrow-icon.b7a7e1bd.svg";